import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { PageQueryService } from 'src/app/services/page-query.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-member-view',
    templateUrl: './member-view.component.html',
    styleUrls: ['./member-view.component.scss']
})
export class MemberViewComponent implements OnInit, OnDestroy {

    constructor(
        public pageQuery: PageQueryService,
        public loading: LoadingService,
        private http: HttpService,
        private auth: AuthService,
        private modalService: NgbModal,
        private toastr: ToastrService
    ) { }
    @ViewChild('deleteModal') deleteModal: any;
    @ViewChild('filterModal') filterModal: any;
    private apiPath = 'members';
    data: any = {};
    util = UtilitiesService;

    filterDialog: any = {
        hasFiler: false,
        modal: null,
        model: {
            last_login_at: {},
            created_at: {},
        },
        show: () => {
            this.filterDialog.modal = this.modalService.open(this.filterModal, { keyboard: false, backdrop: 'static', centered: true, size: 'lg' });
        },
        submit: () => {
            this.filterDialog.hasFilter = false;
            let filterField: any = {};
            if (this.filterDialog.model.last_login_at?.from_date && this.filterDialog.model.last_login_at?.to_date) {
                filterField.last_login_at_from = (this.filterDialog.model.last_login_at.from_date + ' ' + (this.filterDialog.model.last_login_at?.from_time || '00:00')).trim();
                filterField.last_login_at_to = (this.filterDialog.model.last_login_at.to_date + ' ' + (this.filterDialog.model.last_login_at?.to_time || '23:59')).trim();
                this.filterDialog.hasFilter = true;
            }
            if (this.filterDialog.model.created_at?.from_date && this.filterDialog.model.created_at?.to_date) {
                filterField.created_at_from = (this.filterDialog.model.created_at.from_date + ' ' + (this.filterDialog.model.created_at?.from_time || '00:00')).trim();
                filterField.created_at_to = (this.filterDialog.model.created_at.to_date + ' ' + (this.filterDialog.model.created_at?.to_time || '23:59')).trim();
                this.filterDialog.hasFilter = true;
            }
            if (!this.filterDialog.hasFilter) {
                this.filterDialog.hide();
                return;
            }
            this.filterDialog.modal.close();
            filterField.page = 1;
            this.pageQuery.changeRoute(filterField)
        },
        hide: () => {
            this.filterDialog.model = {
                last_login_at: {},
                created_at: {},
            };
            this.filterDialog.hasFilter = false;
            this.filterDialog.modal.close();
            this.pageQuery.changeRoute({ last_login_at_from: '', last_login_at_to: '', created_at_from: '', created_at_to: '', page: 1 });
        }
    }

    deleteDialog: any = {
        ids: [],
        isDeleting: false,
        modal: null,
        show: (ids: Array<any>) => {
            this.deleteDialog.ids = ids;
            this.deleteDialog.modal = this.modalService.open(this.deleteModal, { keyboard: false, backdrop: 'static', centered: true });
        },
        submit: () => {
            this.deleteDialog.isDeleting = true;
            let urlParameters = Object.entries(this.pageQuery.query.getValue()).filter(k => { return k[1] != null }).map(e => e.join('=')).join('&');
            this.http.Delete(this.apiPath + '/delete?' + urlParameters, this.deleteDialog.ids).then((r: any) => {
                this.deleteDialog.isDeleting = false;
                if (r.success) {
                    this.data = r?.response?.result || {};
                    this.deleteDialog.modal.close();
                }
            });
        }
    }

    setStatus(item: any): void {
        const old_status = item.status;
        item.status = item.status ? 0 : 1;
        this.http.Post(this.apiPath + '/set-status', { id: item.id, status: item.status }).then((r: any) => {
            if (!r.success) {
                item.status = old_status;
                return;
            }
            this.toastr.success('Changes saved successfully');
        });
    }

    getData(): void {
        const query: any = this.pageQuery.query.getValue() || {};
        query.limit = query?.limit || 10;
        query.page = query?.page || 1;
        this.http.Get(this.apiPath, query).then((r: any) => {
            if (r.success) {
                this.data = r?.response?.result || {};
            }
        });
    }

    downloadData(): void {
        const pageQuery: any = this.pageQuery.query.getValue() || {};
        let _query: any = {};
        Object.keys(pageQuery).forEach((key) => {
            if (pageQuery[key]) {
                _query[key] = pageQuery[key];
            }
        });
        const query = new URLSearchParams(_query).toString();
        const url = environment.apiUrl + '/' + this.apiPath + '/download?' + query + '&token=' + this.auth.tokenData?.access_token;
        window.open(url, '_blank');
    }

    onSort(ev: any): void {
        const sort = ev.direction == 'desc' ? '-' + ev.column : ev.column;
        this.pageQuery.changeRoute({ order: sort });
    }

    ngOnInit(): void {
        if (!this.pageQuery.queryPage.order) {
            this.pageQuery.queryPage.order = '-last_login_at';
        }
        if (this.pageQuery.queryPage.last_login_at_from && this.pageQuery.queryPage.last_login_at_to) {
            const last_login_from = (this.pageQuery.queryPage.last_login_at_from).split(' ');
            const last_login_to = (this.pageQuery.queryPage.last_login_at_to).split(' ');
            this.filterDialog.hasFilter = true;
            this.filterDialog.model.last_login_at = {
                from_date: last_login_from[0],
                from_time: last_login_from[1],
                to_date: last_login_to[0],
                to_time: last_login_to[1]
            };
        }
        if (this.pageQuery.queryPage.created_at_from && this.pageQuery.queryPage.created_at_to) {
            const created_from = (this.pageQuery.queryPage.created_at_from).split(' ');
            const created_to = (this.pageQuery.queryPage.created_at_to).split(' ');
            this.filterDialog.hasFilter = true;
            this.filterDialog.model.created_at = {
                from_date: created_from[0],
                from_time: created_from[1],
                to_date: created_to[0],
                to_time: created_to[1]
            };
        }
        this.loading.start();
        this.pageQuery.init(() => {
            this.getData();
        });
    }

    ngOnDestroy(): void {
        this.pageQuery.destroy();
    }
}
